export function getNodes<T>({ edges }: { edges: Array<{ node: T }> }): T[] {
    return edges.map(e => e.node);
}
